import MySquid from '@interfaces/my-squid.interface'

export default class ElektraServiceMock {
  public async getConfigByHeader(): Promise<MySquid> {
    return {
      _id: '62e3ef2bb9a054291dcc5697',
      contract: {
        hasContract: false,
        hasPrivacyPolicy: false,
      },
      email: {
        hasEmail: false,
      },
      theme: {
        hasGradient: false,
        secondaryColor: '#c94a4a',
        textColor: '#000000',
        theme: 'both',
        primaryColor: '#92d992',
      },
      metadata: {
        notifications: {
          push: false,
          sms: false,
        },
        validateAccess: {
          hasValidation: false,
          type: 'recruited',
          label: 'CPF',
          mask: 'cpf',
        },
        usersAllowed: [],
        analytics: 'UA-53919009-4',
        pageTitle: 'Influenciadores da Beleza',
      },
      defaultCountry: 'BR',
      bySquid: true,
      organizations: ['5b2a58080cfe240011da9c8e', '56605cfad4c606c85eb10dd6'],
      domains: [
        'grupoboticario.squidit.com.br',
        'boticario.squidit.com.br',
        'revendedoresoboticario.squidit.com.br',
        'stg-grupoboticario.squidit.com.br',
      ],
      payments: true,
      graphics: false,
      active: true,
      name: 'Influenciadores da Beleza',
      organization: {
        _id: '5b2a58080cfe240011da9c8e',
        name: 'Grupo Boticário',
      },
      createdAt: '2022-07-29T14:31:07.677Z',
      updatedAt: '2022-09-28T19:09:48.980Z',
      __v: 0,
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-negativeLogo',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-dev/62e3ef2bb9a054291dcc5697/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-logo',
        },
        backgroundDesktop: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-backgroundDesktop',
        },
        backgroundMobile: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-backgroundMobile',
        },
      },
      aboutLink: 'https://www.grupoboticario.com.br/',
      connection: 'con_RQmaMMRuKGl86ufK',
      replyTo: 'meajuda@squidit.com.br',
      hybridIngressRules: true,
      whatsappLink: 'https://wa.me/5511912233408',
      controlAccess: {
        type: 'email',
        responsableEmail: '',
        spreadsheet: '',
      },
      hasControlAccess: false,
    }
  }
}
